import { useCallback } from "react";

import HeroSection from "../../Components/HeroSection";
import HowItWorksSection from "../../Components/HowItWorksSection";
import BookSpotForm from "../../Components/BookSpotForm";
import BookYogaNutritionTrialRibbon from "../../Components/BookYogaNutritionTrialRibbon";
import WhatMakesShyftBootCampUniqueSection from "../../Components/WhatMakesShyftBootCampUniqueSection";
import CallbackSection from "../../Components/CallbackSection";
import Testimonials from "@/components/Organisms/TestimonialsV2";
import RealWorldTransformation from "../../Components/RealWorldTransformation";
import AppBannerSection from "../../Components/AppBannerSection";
import CallbackStrip from "../../Components/CallbackStrip";
import BootcampListing from "../../Components/BootcampListing";
import AllPackagesSection from "../../Components/AllPackagesSection";
import ReadyToBuildSection from "../../Components/ReadyToBuildSection";
import FaqSection from "@/components/Molecules/FaqSection";
import FloatingBanner from "../../Components/FloatingBanner";
import BookSlotModal from "../../Components/BookSlotModal";
import BookYogaNutritionTrialModal from "../../Components/BookYogaNutritionTrialModal";
import CustomIntercomButton from "../../Components/CustomIntercomButton";

import CertifiedInstructors from "../../Components/Shared/CertifiedInstructors";

import { classNameGenerator } from "@/utils";

import { useAppDispatch, useAppSelector } from "@/hooks";
import * as actions from "@/redux/BootCampReducer";

import styles from "./YogaNutritionBootcampPage.module.scss";

interface YogaNutritionBootcampPageProps {}

const YogaNutritionBootcampPage: React.FC<
  YogaNutritionBootcampPageProps
> = () => {
  const dispatch = useAppDispatch();

  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  const { testimonies } = data?.testimonials || {};
  const faqs = data?.faqs || {};

  const setShowBookYogaNutritionTrialModal = useCallback(
    (value: any) => {
      dispatch(actions.setShowBookYogaNutritionTrialModal(value));
    },
    [dispatch]
  );

  return (
    <div className={cls("yogaNutritionBootcampPage")}>
      <HeroSection />
      <HowItWorksSection>
        <BookSpotForm />
      </HowItWorksSection>
      <BookYogaNutritionTrialRibbon
        onCTAClick={() =>
          setShowBookYogaNutritionTrialModal({
            packageData: data?.trialsData,
          })
        }
      />
      <WhatMakesShyftBootCampUniqueSection />
      <Testimonials testimonies={testimonies} />
      <CallbackSection />
      <RealWorldTransformation />
      <AllPackagesSection />
      <AppBannerSection />
      <CallbackStrip />
      <div className={cls("certifiedInstructors")}>
        <CertifiedInstructors />
      </div>
      <BootcampListing />
      <FaqSection {...faqs} />
      <ReadyToBuildSection />
      <FloatingBanner />
      <BookSlotModal title={data?.bookSlotForm?.title} />
      <BookYogaNutritionTrialModal />
      {/* <CustomIntercomButton /> */}
    </div>
  );
};

export default YogaNutritionBootcampPage;
